export function symbols () {
  return typeof Symbol !== 'undefined' && typeof Symbol.for === 'function'
}
